import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {AgentStatusEnum} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {useUpdateAgentStatus} from '../../inbox/chat/graphql/hooks';
import {getChatStatusText, getChatStatusDescription} from '../../sidebar/helpers';

export function EmbeddedChatStatusToggle() {
    const {updateAgentStatus} = useUpdateAgentStatus();
    const {user} = useGetSessionUser();

    const isAgent = user && user.permissions.canUseOrTryInbox;

    if (!isAgent) {
        return null;
    }

    const handleStatusChange = (status: AgentStatusEnum) => {
        const agentStatus = status === 'ONLINE' ? 'ONLINE' : 'NOT_ACCEPTING_CHATS';
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        user && updateAgentStatus({agentStatus, userId: user.id});
    };

    const currentStatus: AgentStatusEnum = (user && user.agentStatus) || 'NOT_ACCEPTING_CHATS';
    const isOnline = currentStatus === 'ONLINE';

    return (
        <>
            <Divider variant='line--horizontal' color={colors.navyBgActiveNew} />
            <div className='pad-16 mb-16'>
                <StackLegacy spacing={8} alignCenter={true} isHorizontal={true}>
                    <StackLegacy spacing={8}>
                        <Body color='white' size='small' isBold={true}>
                            {getChatStatusText(currentStatus)}
                        </Body>
                        <Body size='small' color='white'>
                            {getChatStatusDescription(currentStatus)}
                        </Body>
                    </StackLegacy>
                    <Switch
                        isOn={isOnline}
                        onChange={() =>
                            handleStatusChange(isOnline ? 'NOT_ACCEPTING_CHATS' : 'ONLINE')
                        }
                        isRounded={true}
                        isSmall={true}
                    />
                </StackLegacy>
            </div>
        </>
    );
}
